import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ui-modal-footer',
  templateUrl: './ui-modal-footer.component.html',
  styleUrls: ['./ui-modal-footer.component.scss'],
})
export class UiModalFooterComponent {
  @Input() primaryLabel = 'Salvar';
  @Input() secondaryLabel = 'Cancelar';
  @Input() primaryDisabled = false;
  @Input() secondaryDisabled = false;
  @Input() showPrimary = true;
  @Input() showSecondary = true;
  @Input() primaryClass = 'btn-primary';
  @Input() secondaryClass = 'cancel';

  @Output() primary = new EventEmitter<void>();
  @Output() secondary = new EventEmitter<void>();
}
